<template lang="pug">
	.recommendation-card
		h3
			| {{plan.name}}
		.disclaimer.no-padding(cols="12" v-if="stateResidencyRequirement(plan)")
			| Restricted to {{plan.state_name}} residents
		.content
			.logo
				img(:src="plan.logo_url" fluid :alt="plan.name + ' logo'")
			.score(v-if="plan.state_abbreviation == state.string_id || stateResidencyRequirement(plan)")
				h4.no-border Our Rating
				sfc-cap-star-score(:isCaps="true" :score="plan.five_caps_resident" :showCount="true")
			.score(v-else)
				h4.no-border Our Rating
				sfc-cap-star-score(:isCaps="true" :score="plan.five_caps_non_resident" :showCount="true")
			.score
				h4
					| Fee Score
					sfc-tooltip-icon.ml-1(:title="tooltipFeeRank")
				sfc-cap-star-score(:isCaps="false" :score="plan.fees_five_star_score" :showCount="true")
			.score
				h4
					span.text-nowrap Performance
						sfc-tooltip-icon.ml-1(:title="tooltipPerfRank")
				div(v-if="plan.one_year_performance_five_star_score && years == 1")
					sfc-cap-star-score(:isCaps="false" :score="plan.one_year_performance_five_star_score" :showCount="true")
				div(v-else-if="plan.three_year_performance_five_star_score && years == 3")
					sfc-cap-star-score(:isCaps="false" :score="plan.three_year_performance_five_star_score" :showCount="true")
				div(v-else-if="plan.five_year_performance_five_star_score && years == 5")
					sfc-cap-star-score(:isCaps="false" :score="plan.five_year_performance_five_star_score" :showCount="true")
				div(v-else-if="plan.ten_year_performance_five_star_score && years == 10")
					sfc-cap-star-score(:isCaps="false" :score="plan.ten_year_performance_five_star_score" :showCount="true")
				div(v-else-if="(years == null || years == undefined || years=='' ) && plan.performance_five_star_score != null")
					sfc-cap-star-score(:isCaps="false" :score="plan.performance_five_star_score" :showCount="true")
				div(v-else)
					.count N/A
			.enroll-now-container
				.is-top-ten(v-if="plan.is_a_top_ten && plan.has_enroll_now" ref="toptenTooltip")
					img(src="https://web-resources.savingforcollege.com/images/top-ten-image.svg")
				sfc-enroll-now-button(click-source="Plan Selection Wizard" :is-red-button="isRedButton" :plan="plan" :page="page" target="_blank" :show-enroll-now-count="true")

</template>

<style lang="stylus" scoped>
@import '../assets/css/variables.styl';

.recommendation-card
	margin: 0 auto 0 auto
	background-color: #fff
	max-width: 800px

	h3
		margin-bottom: 10px
		padding-right: 30%
		@media (max-width: 575px)
			padding: 0 20px
			padding-right: 0

	.disclaimer
		color: sfc-gray-dark
		font-size: body-font-size-xxs
	.content
		display: flex
		justify-content: space-between
		flex-wrap: wrap
		margin-top: 40px
		@media (max-width: 575px)
			display: block
		.logo
			max-width: 110px
			img
				width: 90%
			@media(min-width: 768px)
				max-width: 150px

			@media(max-width: 680px)
				max-width: 70px
			@media (max-width: 630px)
				display: none
		.score
			@media(min-width: 768px)
				max-width: 150px
			h4
				margin-top: 0
			@media (max-width: 575px)
				text-align: center
				h4
					margin-bottom: 10px
					text-align: center
					padding-top: 20px
					border-top: 1px solid sfc-pale-gray
					margin: 10px 30px
					&.no-border
						border-top: 0
				.score-box
					display: inline-block
					>>> .cap-rating
					>>> .star-img
						display: inline-block
					>>> .count
						text-align: center
						padding-top: 0
		.enroll-now-container
			.is-top-ten
				width: 90px
				margin: auto
				margin-top: -60px
				img
					width: 100%
			@media (max-width: 575px)
				margin: 20px auto 30px auto
				max-width: 200px
				text-align: center
				>>> .secure-message
					display: none
				.is-top-ten
					display: none
</style>
<script>
	import {directive as onClickOutside} from 'vue-on-click-outside'
	// import SfcUtil from "@/lib/sfc-util.js"
	import SfcCapStarScore from './cap-star-score'
	import SfcEnrollNowButton from './sfc-enroll-now-button'
	import SfcTooltipIcon from './tooltip-icon'
	import Vue from 'vue'
	Vue.directive('on-click-outside', onClickOutside)

	export default {

		props: ['plan', 'showTooltip', 'years', 'isRedButton', 'page', 'enrollNowParams', 'hasStateTaxDeduction', 'state', 'clickSource'],

		components: {
			SfcCapStarScore,
			SfcEnrollNowButton,
			SfcTooltipIcon
		},

		data() {
			let tooltipFeeRank = "The fee score is derived from the analysis of costs done as part of Savingforcollege.com's 5-Cap Rating. This analysis compares total average asset-based expenses of the plan to other 529 savings plans. See the <a href='https://www.savingforcollege.com/5-cap-ratings/ratings-criteria' target='_blank'>methodology</a> for more information."
			let tooltipPerfRank = "The performance score is based on Savingforcollege.com's composite ranking for five-year investment performance. In producing our rankings, we compare the reported investment performance of a subset of portfolios from each 529 savings plan."

			return {
				ready: true,
				internalShowTooltip: true,
				selectedPlans: [],
				displayPlanDetails: [],
				tooltipDisabled: true,
				showMore: false,
				tooltipFeeRank,
				tooltipPerfRank
			}
		},

		computed:{
			computedShowTooltip(){
				return this.showTooltip && this.internalShowTooltip
			}
		},
		methods: {
			stateResidencyRequirement(plan){
				if(["No", "None", "--", null, undefined].indexOf(plan.state_residency_requirements) != -1 || plan.state_residency_requirements == ""){
					return false
				}
				return true
			},

			closePopover(){
				this.internalShowTooltip = false
			},

		}
	}
</script>
